import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createHarness } from '@/lib/api/generated/api';

import { toHarnessError } from '../errors';
import { harnessKeys } from '../queryKeys';
import type { Harness, HarnessWriteInput } from '../types';

/** Create a new Harness for the organization. */
export function useCreateHarness() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: HarnessWriteInput): Promise<Harness> => {
      const response = await createHarness({
        name: body.name,
        harness_type: body.harness_type,
        base_url: body.base_url,
        token: body.token ?? '',
        ...(body.wire_api === undefined ? {} : { wire_api: body.wire_api }),
      });
      if (response.status === 201) return response.data;
      throw toHarnessError(response.status, response.data);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: harnessKeys.all() });
    },
  });
}
